var _defs, _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmoji(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sentiment_satisfied_alt_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#484848}\n        "))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17816",
    "data-name": "Path 17816",
    d: "M0 0h20v20H0z",
    style: {
      fill: "none"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1821",
    "data-name": "Ellipse 1821",
    className: "cls-2",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(11.333 6.476)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1822",
    "data-name": "Ellipse 1822",
    className: "cls-2",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(5.667 6.476)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17817",
    "data-name": "Path 17817",
    className: "cls-2",
    d: "M10 13.2a3.2 3.2 0 0 1-2.76-1.6H5.9a4.4 4.4 0 0 0 8.192 0H12.76A3.188 3.188 0 0 1 10 13.2zM9.992 2A8 8 0 1 0 18 10a8 8 0 0 0-8.008-8zM10 16.4a6.4 6.4 0 1 1 6.4-6.4 6.4 6.4 0 0 1-6.4 6.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.cf5d1ef9de6338dab0fe042569c36cea.svg";
export { ForwardRef as ReactComponent };